export default "__VITE_ASSET__DPYi8EEf__"